var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from "react";
import { useAuth } from "../rx/useAuth";
import { SignInForm } from "../components/SignInForm";
export default function withAuthentication(Component) {
    return memo(function (props) {
        var _a = useAuth(), isAuthenticating = _a.isAuthenticating, isAuthenticated = _a.isAuthenticated, authenticate = _a.authenticate;
        if (!isAuthenticated) {
            return React.createElement(SignInForm, { authenticate: authenticate, isAuthenticating: isAuthenticating });
        }
        return React.createElement(Component, __assign({}, props));
    });
}
